import { render } from "./Layout.vue?vue&type=template&id=3e8de96e"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"
script.render = render

export default script